import { Avatar, Chip, Tooltip } from '@mui/material';
import { FC } from 'react';
import { AppBar, AppBarProps, useGetIdentity, UserMenu } from 'react-admin';
import { AgentAvailabilitySelector } from '../components/communications-center/phone-calls/AgentAvailabilitySelector/AgentAvailabilitySelector';
import { GlobalCallModals } from '../components/communications-center/phone-calls/GlobalCallModals/GlobalCallModals';
import { usePhoneCalls } from '../contexts/PhoneCallsContext/PhoneCallsContext';
import { AgentAvailabilityStatus } from '../interfaces/calls';

const CustomUserIcon: FC = () => {
  const { identity, loading: identityLoading } = useGetIdentity();
  return (
    <>
      {identityLoading ? (
        <div>
          <span>{identity?.fullName}</span>
          <Avatar src='/user-default.png' />
        </div>
      ) : null}
    </>
  );
};

const CustomUserMenu: FC<{ icon: JSX.Element }> = (props) => {
  const { agent, agentAvailability, agentBootstrapState, retryAgentBootstrap } = usePhoneCalls();

  // `> 0` rather than a bare `.length`: with an empty array the old expression
  // evaluated to `0`, which React renders as a literal "0" in the app bar.
  const canShowAvailability =
    (agent?.trackingNumbers?.incoming.length ?? 0) > 0 &&
    agentAvailability.currentStatus !== AgentAvailabilityStatus.DISABLED;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
      }}
    >
      {/* Without these chips a failed bootstrap is indistinguishable from "you
          have no phone" — the widget just silently never appears. */}
      {agentBootstrapState === 'error' && (
        <Tooltip title='Your phone could not be set up. Click to try again.'>
          <Chip
            label='Phone unavailable'
            color='warning'
            size='small'
            onClick={retryAgentBootstrap}
          />
        </Tooltip>
      )}
      {agentBootstrapState === 'not-configured' && (
        <Tooltip title='No agent profile is linked to your account. Contact an administrator.'>
          <Chip label='No agent profile' size='small' />
        </Tooltip>
      )}
      {canShowAvailability && <AgentAvailabilitySelector />}
      <UserMenu {...props}></UserMenu>
    </div>
  );
};

export const CustomAppBar: FC<AppBarProps> = (props) => (
  <>
    <AppBar userMenu={<CustomUserMenu icon={<CustomUserIcon />} />} {...props} />
    <GlobalCallModals />
  </>
);
